var nlNlTranslation = {
    "contact_us.buttonText": "Help",
    "contact_us.error.email": "Voer alsjeblieft een geldig e-mailadres in",
    "contact_us.error.general": "Oeps... Er is iets verkeerd gegaan. Probeer het opnieuw.",
    "contact_us.error.minimum_two_chars": "Moet minimaal 2 tekens lang zijn",
    "contact_us.placeholders.email": "E-mailadres",
    "contact_us.placeholders.name": "Volledige Naam",
    "contact_us.placeholders.text": "Hoe kunnen we je helpen?",
    "contact_us.send": "VERSTUUR",
    "contact_us.subtitle": "Vul je gegevens in, stel je vraag en dan komen we z.s.m. bij je terug",
    "contact_us.success.ok": "ok\xe9",
    "contact_us.success.subtitle": "We hebben je bericht ontvangen en nemen zo snel mogelijk contact met je op.",
    "language.select.label": "Selecteer uw taal",
    "contact_us.success.title": "Bedankt {{name}}!",
    "contact_us.title": "STEL HIER JE VRAGEN",
    "cookie_consent.customize.categories.essential.description": "Deze cookies zijn bedoeld om je een optimale ervaring te bieden en de site te beheren zonder persoonlijke identificeerbare informatie te delen met derden",
    "cookie_consent.customize.categories.essential.title": "Essenti\xeble cookies (altijd aan)",
    "cookie_consent.customize.categories.performance.description": "Deze cookies helpen ons prestaties te meten en bezoeken aan onze site te analyseren, zodat we onze gebruikerservaring kunnen blijven verbeteren",
    "cookie_consent.customize.categories.performance.title": "Prestatie cookies",
    "cookie_consent.customize.confirm_btn_title": "Bevestigen",
    "cookie_consent.customize.title": "Cookies Aanpassen",
    "cookie_consent.information.accept_btn_title": "accepteren",
    "cookie_consent.information.cookies_policy_link_text": "Cookiebeleid",
    "cookie_consent.information.customize_btn_title": "aanpassen",
    "cookie_consent.information.description": "Wij gebruiken cookies en andere technologie\xebn om je de best mogelijke gebruikerservaring te bieden en om reclame op en buiten onze website te personaliseren. Daarnaast kunnen onze partners cookies of andere technologie\xebn gebruiken om jou marketinginformatie te verstrekken. Als je alle niet-essenti\xeble cookies wilt uitschakelen, kun je op “Aanpassen” klikken. Meer informatie over hoe wij cookies gebruiken en jouw recht om je af te melden vind je in ons cookiebeleid.",
    "cookie_consent.information.title": "lemonade en cookies",
    "cxai.browser_toast": "Voor een optimale chatervaring raden wij\nChrome, Safari of Edge browsers aan",
    "cxai.default_description": "Persoonlijke verzekeringsassistente",
    "cxai.error.message": "Er is iets misgegaan...",
    "cxai.error.retry": "Probeer opnieuw",
    "cxai.phone_input.mobile_title": "",
    "cxai.phone_input.no_results": "",
    "cxai.phone_input.placeholder": "",
    "cxai.restart.action": "JA",
    "cxai.restart.close": "NEE",
    "cxai.restart.content": "Kan ik je ergens anders\nnog mee helpen?",
    "cxai.restart.title": "Opnieuw beginnen",
    "error_page.action": "Terug naar startpagina",
    "error_page.subtitle": "We kunnen de pagina niet vinden…",
    "error_page.title": "Oeps.",
    "footer.disclaimer": "Let op: deze definities veranderen niets aan de voorwaarden, uitzonderingen of beperkingen van de polissen die Lemonade uitgeeft. Ze zijn uitsluitend bedoeld voor educatieve doeleinden. Ze zijn niet bedoeld om te worden gebruikt in plaats van professioneel juridisch of financieel advies. We zullen ons best doen om deze termen actueel te houden, maar ze zullen niet altijd  de huidige ontwikkelingen in de sector reflecteren. Je bent van harte welkom om de termen met bronvermelding te gebruiken (vrienden laten andere vrienden natuurlijk geen plagiaat plegen!). \n\nLemonade Insurance N.V. is een schadeverzekeraar met een vergunning van De Nederlandsche Bank (DNB) met relatienummer R162036. Lemonade Insurance N.V. is geregistreerd bij de Autoriteit Financi\xeble Markten (AFM) onder nummer 12047353 en ingeschreven bij de Kamer van Koophandel (KvK) onder nummer 73227420.\n \nLemonade Insurance N.V. heeft Lemonade Agency B.V. aangesteld als haar gevolmachtigde agent voor de distributie van haar verzekeringsproducten. Lemonade Agency B.V. is geregistreerd bij de AFM onder nummer 12047085 en ingeschreven bij de KvK onder nummer 75134454.",
    "footer.titles.company": "bedrijf",
    "footer.titles.homeContentInsurance": "Inboedelverzekering",
    "footer.titles.liabilityInsurance": "Aansprakelijkheidsverzekering",
    "footer.titles.buildingInsurance": "Opstalverzekering",
    "footer.titles.features": "features",
    "footer.titles.get_app": "download onze app",
    "footer.titles.products": "",
    "footer.titles.resources": "Meer Info",
    "footer.titles.social": "volg ons",
    "footer.titles.contact": "Neem contact met ons op",
    "header.actions.login": "Mijn account",
    "header.actions.logout": "Uitloggen",
    "header.actions.settings": "Instellingen",
    "header.accessibility.title": "Toegankelijkheid",
    "header.api.title": "",
    "header.blank.title": "",
    "header.blog.title": "Blog",
    "header.car.title": "",
    "header.car_explained.title": "",
    "header.claims.title": "Claims",
    "header.community.title": "",
    "header.covid_19.title": "",
    "header.expats_de.title": "",
    "header.expats_nl.title": "",
    "header.giveback.title": "Giveback",
    "header.faq.title": "FAQ",
    "header.giveback_2021.title": "Giveback",
    "header.global_expansion.title": "Beschikbaar in",
    "header.home.title": "Startpagina",
    "header.homeowners.title": "",
    "header.imprint.title": "Colofon",
    "header.insurance_card.title": "Verzekeringskaarten",
    "header.insuropedia.title": "Woordenboek",
    "header.investors.title": "",
    "header.legal_stuff.title": "De kleine lettertjes",
    "header.life.title": "",
    "header.makers.title": "Join the Team",
    "header.manage_cookies.title": "Cookies beheren",
    "header.partners_program.title": "",
    "header.personal_liability_hub.title": "Aansprakelijkheid uitgelegd",
    "header.pet.title": "",
    "header.pet_dog_insurance_explained.title": "",
    "header.pet_insurance.title": "",
    "header.policy_two.title": "Polis 2.0",
    "header.privacy_policy.title": "Privacybeleid",
    "header.renters.title": "",
    "header.renters_hub.title": "Tips",
    "header.reviews.title": "",
    "header.sitemap.title": "Sitemap",
    "header.term_life.title": "",
    "header.terms_of_service.title": "Voorwaarden",
    "header.transparency.title": "",
    "nav.accessibility.title": "Toegankelijkheid",
    "nav.api.title": "",
    "nav.blank.title": "",
    "nav.blog.title": "Blog",
    "nav.car.title": "",
    "nav.car_explained.title": "",
    "nav.claims.title": "Claims",
    "nav.community.title": "",
    "nav.covid_19.title": "",
    "nav.expats_de.title": "",
    "nav.expats_nl.title": "",
    "nav.faq.title": "FAQ",
    "nav.giveback.title": "Giveback",
    "nav.giveback_2021.title": "Giveback",
    "nav.global_expansion.title": "Beschikbaar in",
    "nav.home.title": "Startpagina",
    "nav.homeowners.title": "",
    "nav.imprint.title": "Colofon",
    "nav.insurance_card.title": "Verzekeringskaarten",
    "nav.insuropedia.title": "Woordenboek",
    "nav.insuropedia_nl.title": "Woordenboek",
    "nav.investors.title": "",
    "nav.legal_stuff.title": "De kleine lettertjes",
    "nav.life.title": "",
    "nav.global_blog_nl.title": "Blog",
    "nav.phone_insurance_hub.title": "Telefoon verzekeren",
    "nav.makers.title": "Join the Team",
    "nav.manage_cookies.title": "Cookies beheren",
    "nav.partners_program.title": "",
    "nav.personal_liability_hub.title": "Aansprakelijkheidsverzekering begrijpen",
    "nav.pet.title": "",
    "nav.insuring_e_bike_hub.title": "E-bike verzekeren",
    "nav.bicycle_insurance_hub.title": "Fietsverzekeringen",
    "nav.private_liability_insurance_hub.title": "Zo haal je alles uit je aansprakelijkheidsverzekering",
    "nav.what_is_building_insurance.title": "Wat is een opstalverzekering",
    "nav.how_much_does_home_insurance_cost.title": "Wat kost een opstalverzekering",
    "nav.differences_between_content_and_building_insurance.title": "Verschil opstal en inboedel",
    "nav.mandatory_building_insurance.title": "Is een opstalverzekering verplicht",
    "nav.woz_value.title": "Wat is WOZ-waarde",
    "nav.apartment_building_insurance.title": "Opstalverzekering appartement",
    "nav.third_party_liability_insurance_hub.title": "Wat is een WA-verzekering?",
    "nav.liability_insurance_hub.title": "Aansprakelijkheidsverzekeringen uitgelegd",
    "nav.pet_dog_insurance_explained.title": "",
    "nav.pet_insurance.title": "",
    "nav.policy_two.title": "Polis 2.0",
    "nav.cost_content_insurance_hub.title": "Kosten van een inboedelverzekering",
    "nav.privacy_policy.title": "Privacybeleid",
    "nav.home_content_insurance_hub.title": "Waarom een inboedelverzekering belangrijk is",
    "nav.renters.title": "",
    "nav.renters_hub.title": "Inboedelverzekering begrijpen",
    "nav.reviews.title": "",
    "nav.sitemap.title": "Sitemap",
    "nav.term_life.title": "",
    "nav.terms_of_service.title": "Voorwaarden",
    "nav.transparency.title": "",
    "privacy_banner.content": "We gebruiken cookies en andere technologie\xebn om je de best mogelijke gebruikservaring aan te bieden en om advertenties op en buiten onze website aan te passen. Daarnaast kunnen onze partners cookies en andere technologie\xebn gebruiken om je te voorzien van marketinginformatie. Lees meer hierover en over jouw recht om je af te melden in ons [Privacybeleid](privacyPolicyLink).",
    "privacy_banner.cta": "Accepteer",
    "cookie_consent.information.reject_btn_title": "Afwijzen",
    "cookie_consent.customize.categories.tracking.title": "Targeting/advertising cookies",
    "cookie_consent.customize.categories.tracking.description": "Dit zijn marketing cookies die ons helpen de meest gepersonaliseerde aanbiedingen te doen",
    "nav.do_not_share_my_personal_information.title": "Deel mijn persoonlijke informatie niet.",
    "cookie_consent.customize.personalInfo.block3.description": "Als je een account bij ons hebt en je gegevens wilt wijzigen of verwijderen, stuur dan een e-mail naar privacy@lemonade.com of bel ons gratis op 844-733-8666.",
    "cookie_consent.customize.personalInfo.block1.description": "We gebruiken informatie die via cookies worden verzameld om je de best mogelijke ervaring te bieden. Maar, geen zorgen, je kunt er op elk moment ervoor kiezen om geen cookies te gebruiken. Als inwoner van Californi\xeb heb je rechten met betrekking tot de verkoop van persoonlijke informatie."
};

export { nlNlTranslation as default };
